<template>
<div>
  <van-field 
    :label="schema.label"
    :name="schema.name + '_' +schema.uniqid"
    bind:click-input="imgUploaderClick"
    :required="schema.required === true" 
    :rules="[{ required: schema.required === true ,message:'请上传'+schema.label}]"
  >
    <template slot="input" v-if="schema.isCamera">
      <van-uploader v-model="schema.fileList" 
        :preview-size="schema.previewSize" 
        :upload-icon="schema.uploadIcon" 
        :upload-text="schema.uploadText" 
        capture="camera"
        :max-count="schema.maxCount"
        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,image/svg"
        :before-read="imgUploaderBeforeRead"
        :after-read="imgUploaderAfterRead"
      />
    </template>
    <template slot="input" v-else>
      <van-uploader v-model="schema.fileList" 
        :preview-size="schema.previewSize" 
        :upload-icon="schema.uploadIcon" 
        :upload-text="schema.uploadText" 
        :max-count="schema.maxCount"
        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,image/svg"
        :before-read="imgUploaderBeforeRead"
        :after-read="imgUploaderAfterRead"
      />
    </template>
  </van-field>
</div>
</template>

<script>
import Compressor from 'compressorjs';
import { Dialog } from 'vant';
import { mapState } from 'vuex'
// import { Notify } from 'vant';

export default {
  name: 'imgUploader',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  computed:{
    ...mapState(['config']),
  },
  methods:{//选中组件
    imgUploaderClick:function(){
      // this.pluginIndex = pluginIndex;
    },
    //读取前压缩
    imgUploaderBeforeRead:function(file){
     
      //格式限制
      if(file.type !='image/jpeg' && file.type !='image/jpg' && file.type !='image/png' && file.type !='image/webp' && file.type !='image/svg'  && file.type !='image/svg+xml'){

        Dialog.alert({
          title: '提示',
          message: '请上传 jpg、png、gif、webp 格式的照片',
          closeOnClickOverlay:true
        }).then(() => {
          // on close
        }).catch(() => {
          // on cancel
        });
        return false;
      }

       //不压gif webp svg
      if(file.type !='image/jpeg' && file.type !='image/jpg' && file.type !='image/png'){
        return file;
      }


      //压缩图
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: 0.9,
          maxWidth:1624,
          maxHeight:1624,
          success: resolve,
          error(err) {
            Dialog.alert({
              title: '提示',
              message: '照片处理失败，建议更换一张：'+ err.message,
              closeOnClickOverlay:true
            }).then(() => {
              // on close
            }).catch(() => {
              // on cancel
            });

          },
        });
      });
    },
    //这里的 file = fileList[detail.index]
    imgUploaderAfterRead:function(fileListItem,detail){

      var that = this;
      // console.log(fileListItem,detail)

      fileListItem.status = 'uploading';
      fileListItem.message = '上传中...';

      // console.log('上传中',fileListItem.file.name,this.config.apiDomain);

      const formData = new FormData();
      formData.append('file', fileListItem.file,fileListItem.file.name);
      formData.append('source','diy_form');
      formData.append('qr_scene',this.config.qrScene);

      this.$http.post( this.config.apiDomain + '/Fileupload/diy_form.html',formData,{emulateJSON:true}).then(function (response) {

            var res = response.data;
       
            if(res.code ==1){
              // console.log('post res',res);

              //保存成功后的一些动作
              fileListItem.status = 'done';
              fileListItem.message = 'success';
              fileListItem.url = res.data.url; 
              fileListItem.name = fileListItem.file.name;
              fileListItem.size = fileListItem.file.size;
              fileListItem.attach_scene = res.data.attach_scene; 
              //onSubmit 再把 文件对象删除，不提交服务器
              // delete fileListItem.content;
              // delete fileListItem.file;
              // console.log(this.pluginArray[this.pluginIndex].fileList);

              // console.log('schema',that.schema)

            }else{
              //错误
              fileListItem.status = 'failed';
              fileListItem.message = res.msg;

              // console.log(this.pluginArray[this.pluginIndex].fileList);

              Dialog.alert({
                title: '提示',
                message: res.msg,
                closeOnClickOverlay:true
              }).then(() => {
                // on close
              }).catch(() => { });

            }
        }).catch(function (error) {
          console.log(error);
          Dialog.alert({
            title: '提示',
            message: '请求发生错误，请稍后再试',
            closeOnClickOverlay:true
          }).then(() => {
            // on close
          }).catch(() => { });
        });



      // setTimeout(() => {
      //   fileListItem.status = 'done';
      //   fileListItem.message = 'success';
      //   fileListItem.url = '/static/images/demo-placeholder.jpg'; 
      //   fileListItem.name = fileListItem.file.name;
      //   fileListItem.size = fileListItem.file.size;

      //   //onSubmit是再把 文件对象删除，不提交服务器
      //   // delete fileListItem.content;
      //   // delete fileListItem.file;

      //   console.log(this.pluginArray[this.pluginIndex].fileList);
      // }, 1000);
 



    
    
    }
  }
}
</script>

<style>

</style>